<div [formGroup]="form">
  @for (question of category.questions; track question.id) {
    @switch (question.type) {
      @case ("textarea") {
        <div class="form-group">
          <p-floatLabel>
            <textarea
              pInputTextarea
              [autoResize]="true"
              [formControlName]="QUESTION_PREFIX + question.id"
              class="feedback-textarea"
            ></textarea>
            <label>{{ question.text }}</label>
          </p-floatLabel>
          @if (isInvalid(QUESTION_PREFIX + question.id)) {
            <small class="p-error">Antwort erforderlich</small>
          }
        </div>
      }
      @case ("radio") {
        <div class="form-group">
          <label class="default-label">{{ question.text }} </label>
          @for (opt of question.options; track opt.value) {
            <p-radioButton
              [formControlName]="QUESTION_PREFIX + question.id"
              [value]="opt.value"
              inputId="{{ QUESTION_PREFIX + question.id + '_' + opt.value }}"
              name="{{ QUESTION_PREFIX + question.id }}"
              class="custom-radio-button"
              [label]="opt.label"
            />
          }
          @if (isInvalid(QUESTION_PREFIX + question.id)) {
            <small class="p-error">Antwort erforderlich</small>
          }
        </div>
      }
      @case ("checkbox") {
        <div class="form-group">
          <p-checkbox
            [formControlName]="QUESTION_PREFIX + question.id"
            [binary]="true"
            class="custom-radio-button default-label"
            [label]="question.text"
          />
          @if (isInvalid(QUESTION_PREFIX + question.id)) {
            <small class="p-error">Antwort erforderlich</small>
          }
        </div>
      }
      @case ("number") {
        <div class="form-group">
          <label class="default-label">{{ question.text }}</label>
          <p-inputNumber [formControlName]="QUESTION_PREFIX + question.id" />
          @if (isInvalid(QUESTION_PREFIX + question.id)) {
            <small class="p-error">Antwort erforderlich</small>
          }
        </div>
      }
      @case ("date") {
        <div class="form-group">
          <label class="default-label">{{ question.text }}</label>
          <input
            pInputText
            [formControlName]="QUESTION_PREFIX + question.id"
            type="date"
          />
          @if (isInvalid(QUESTION_PREFIX + question.id)) {
            <small class="p-error">Antwort erforderlich</small>
          }
        </div>
      }
      @default {
        <div class="form-group">
          <p-floatLabel>
            <input
              pInputText
              [formControlName]="QUESTION_PREFIX + question.id"
            />
            <label>{{ question.text }}</label>
          </p-floatLabel>
          @if (isInvalid(QUESTION_PREFIX + question.id)) {
            <small class="p-error">Antwort erforderlich</small>
          }
        </div>
      }
    }
  }
</div>
